var Globals = {
	Google : {
		tagKey:'',
		mapKey:''
	},
	siteId:null,
	currencyForCookie:null,
	locale:'tr'
};